<template>
  <px-lateral-dialog v-model="dialog" width="800">
    <template v-slot:activator="{ on }">
      <v-tooltip top>
        <template v-slot:activator="{ on: onTooltip }">
          <v-btn icon
                 color="error"
                 v-on="{ ...onTooltip, ...on }">
            <v-icon>mdi-cancel</v-icon>
          </v-btn>
        </template>
        <span>Cancelar contratação</span>
      </v-tooltip>
    </template>
    <template v-slot:title>
      Cancelar contratação
    </template>
    <template>
      <v-row>
        <v-col cols="12">
          <v-textarea
            outlined
            auto-grow
            class="required"
            label="Motivo do cancelamento"
            counter="1500"
            rows="4"
            v-model="motivoRecusa"
            :error="$v.motivoRecusa.$error"
            @blur="$v.motivoRecusa.$touch()"
          />
        </v-col>
      </v-row>
    </template>
    <template v-slot:actions>
      <v-spacer/>
      <v-btn @click="close">
        Fechar
      </v-btn>
      <v-btn color="primary" :loading="loading" @click="onClickCancelar">
        Enviar cancelamento
      </v-btn>
    </template>
  </px-lateral-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import validationMixin from '@/mixins/validation-mixin';
import ContratacaoService from '../contratacao-frete-service';

export default {
  props: {
    contratacao: Object,
  },
  mixins: [validationMixin],
  data() {
    return {
      dialog: false,
      loading: false,
      motivoRecusa: null,
    };
  },
  methods: {
    onClickCancelar() {
      if (this.validateForm()) {
        return;
      }
      this.cancelar();
    },
    cancelar() {
      this.loading = true;
      ContratacaoService.cancelar(this.contratacao.id, this.buildContratacao())
        .then(() => {
          this.$emit('movimentar');
          this.$toast('Contratação cancelada', { color: 'success' });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    close() {
      this.dialog = false;
    },
    buildContratacao() {
      return {
        id: this.contratacao.id,
        motivo: this.motivoRecusa,
      };
    },
  },
  validations: {
    motivoRecusa: {
      required,
    },
  },
};
</script>
